import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { removeCookie } from "../../utils/cookies";
import toast from "../../utils/toast";
import { getCookie } from "../../utils/cookies";

const PAGE_TITLES = {
  "/panel/dashboard": "Dashboard",
  "/panel/activate_package": "Activate Package",
  "/panel/courses": "My Courses",
  "/panel/wallets": "Wallets",
  "/panel/team_reports": "Reports",
  "/panel/profile": "Profile",
  "/panel/complain_list": "Complaint List",
  "/panel/create_complain": "Create Complaint",
  "/panel/quick_deposit": "Quick Deposit",
  "/panel/manual_deposit": "Manual Deposit",
};

export default function Header({ isSidebarOpen, onToggleSidebar }) {
  const location = useLocation();
  const navigate = useNavigate();
  const pageTitle = PAGE_TITLES[location.pathname] || "Dashboard";
  const [showMenu, setShowMenu] = useState(false);

  const userData = JSON.parse(getCookie("userData") || "{}");

  function getInitials(name) {
    if (!name) return "?";
    const parts = name.trim().split(/\s+/);
    return parts
      .slice(0, 2)
      .map((p) => p[0])
      .join("")
      .toUpperCase();
  }

  function handleLogout() {
    removeCookie("sessionID");
    removeCookie("session");
    removeCookie("userData");
    toast.success("Logged out successfully");
    navigate("/panel/login");
  }

  return (
    <>
      <div className="topbar">
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <button
            className={`mobile-menu-toggle${isSidebarOpen ? " active" : ""}`}
            onClick={onToggleSidebar}
          >
            <span />
            <span />
            <span />
          </button>
          <div className="page-title" id="pageTitle">
            {pageTitle}
          </div>
        </div>
        <div className="topbar-right">
          <div style={{ position: "relative" }}>
            <div
              className="user-chip"
              onClick={() => setShowMenu((prev) => !prev)}
            >
              <div className="avatar">{getInitials(userData.name)}</div>
              <div style={{ textAlign: "left" }}>
                <div className="user-chip-name">{userData.name}</div>
                <div className="user-chip-id">
                  ID : {userData.prefix}
                  {userData.userID}
                </div>
              </div>
            </div>
            {showMenu && (
              <>
                <div
                  onClick={() => setShowMenu(false)}
                  style={{ position: "fixed", inset: 0, zIndex: 998 }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: "calc(100% + 10px)",
                    right: 0,
                    minWidth: 170,
                    background: "var(--bg-elev-2)",
                    border: "1px solid var(--border)",
                    borderRadius: 10,
                    padding: 6,
                    boxShadow: "0 12px 30px -8px rgba(0,0,0,0.5)",
                    zIndex: 999,
                  }}
                >
                  <button
                    type="button"
                    onClick={handleLogout}
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      textAlign: "left",
                      padding: "9px 12px",
                      background: "transparent",
                      border: "none",
                      borderRadius: 7,
                      color: "var(--text)",
                      fontSize: 13,
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.background = "var(--bg-elev-3)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.background = "transparent")
                    }
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      width={16}
                      height={16}
                    >
                      <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
                      <path d="M16 17l5-5-5-5" />
                      <path d="M21 12H9" />
                    </svg>
                    Logout
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
